const featureCards = [
  ["19+ anos", "Atendimento consultivo para familias, profissionais e empresas."],
  ["12 linhas", "Carteira ampla para comparar cobertura, franquia e seguradora."],
  ["Cuiaba - MT", "Atendimento presencial e remoto para cotacoes e renovacoes."],
  ["Parceiros", "Seguradoras reconhecidas para ampliar opcoes de contratacao."]
];

const serviceCards = [
  ["Seguro Vida", "Protecao financeira para familia, socios e sucessao.", "domazi-icon-vida.jpg"],
  ["Seguro Saude", "Planos e coberturas para pessoas e empresas.", "domazi-icon-saude.jpg"],
  ["Risco de Engenharia", "Obras, instalacoes e execucao tecnica com exposicao controlada.", "domazi-icon-risco.jpg"],
  ["Residencial", "Casa, apartamento, assistencias e patrimonio familiar.", "domazi-icon-residencial.jpg"],
  ["Previdencia", "Planejamento de longo prazo com orientacao objetiva.", "domazi-icon-previdencia.jpg"],
  ["Seguro Garantia", "Contratos, licitacoes e obrigacoes com respaldo tecnico.", "domazi-icon-garantia.jpg"],
  ["Empresarial", "Cobertura para operacao, equipamentos, estoque e responsabilidade.", "domazi-icon-empresarial.jpg"],
  ["Embarcacoes", "Protecao para embarcacoes e uso recreativo ou profissional.", "domazi-icon-embarcacao.jpg"],
  ["Centrais Hidreletricas", "Risco operacional para estruturas e ativos especializados.", "domazi-icon-hidreletrica.jpg"],
  ["Automovel", "Seguro auto com assistencia, cobertura e seguradora adequada.", "domazi-icon-auto.jpg"],
  ["Aeronautico", "Cotacao orientada para aeronaves e operacoes especificas.", "domazi-icon-aeronautico.jpg"],
  ["Outros seguros", "Avaliacao sob demanda quando o risco exige solucao especifica.", "domazi-icon-garantia.jpg"]
];

const gallery = [
  ["Seguro de vida", "domazi-hero-vida.jpg"],
  ["Seguro saude", "domazi-hero-saude.jpg"],
  ["Seguro residencial", "domazi-hero-residencial.jpg"],
  ["Seguro empresarial", "domazi-hero-empresarial.jpg"],
  ["Seguro auto", "domazi-hero-auto.jpg"]
];

const insurers = [
  ["Porto Seguro", "domazi-porto.jpg"],
  ["Tokio Marine", "domazi-tokio.jpg"],
  ["Liberty", "domazi-liberty.jpg"],
  ["Zurich", "domazi-zurich.jpg"],
  ["SulAmerica", "domazi-sulamerica.jpg"],
  ["Mapfre", "domazi-mapfre.jpg"],
  ["Itau", "domazi-itau.jpg"],
  ["HDI", "domazi-hdi.jpg"],
  ["Bradesco", "domazi-bradesco.jpg"],
  ["Chubb", "domazi-chubb.jpg"],
  ["Parceiro", "domazi-partner-layer18.png"]
];

const contactItems = [
  ["phone", "(65) 3388-4520", "tel:6533884520"],
  ["mail", "domazi@grupodomani.com.br", "mailto:domazi@grupodomani.com.br"],
  ["pin", "Av. Joaquim Louzada, 3015 - Cuiaba", "#contato"]
];

function App() {
  const quoteHref =
    "mailto:domazi@grupodomani.com.br?subject=Solicitacao%20de%20orcamento%20-%20Domazi%20Seguros";

  return (
    <main>
      <header className="site-header" aria-label="Navegacao principal">
        <a className="brand" href="#inicio" aria-label="Domazi Seguros">
          <img src="/assets/domazi-logo.png" alt="Domazi Seguros" />
        </a>
        <nav>
          <a href="#sobre">Sobre</a>
          <a href="#servicos">Servicos</a>
          <a href="#parceiros">Parceiros</a>
          <a href="#contato">Contato</a>
        </nav>
        <a className="header-action" href={quoteHref}>Solicitar orcamento</a>
      </header>

      <section id="inicio" className="hero">
        <picture className="hero-media">
          <img src="/assets/domazi-hero-vida.jpg" alt="Familia protegida por seguro de vida" />
        </picture>
        <div className="hero-content">
          <p className="eyebrow">Corretora de seguros em Cuiaba</p>
          <h1>Seguro certo, escolhido com criterio.</h1>
          <p>
            A Domazi orienta cotacoes para vida, saude, patrimonio, empresas e riscos especiais
            com seguradoras reconhecidas e atendimento direto.
          </p>
          <div className="hero-actions">
            <a className="button primary" href={quoteHref}>Fazer cotacao</a>
            <a className="button secondary" href="tel:6533884520">(65) 3388-4520</a>
          </div>
        </div>
      </section>

      <section className="proof-strip" aria-label="Resumo operacional">
        {featureCards.map(([title, text]) => (
          <article key={title}>
            <strong>{title}</strong>
            <span>{text}</span>
          </article>
        ))}
      </section>

      <section id="sobre" className="intro">
        <div>
          <p className="section-label">Seguro de qualidade</p>
          <h2>Consultoria para proteger patrimonio, vida e operacao.</h2>
        </div>
        <div>
          <p>
            A Domazi Seguros trabalha com analise de necessidade, perfil de risco e comparacao
            entre seguradoras. A proposta nao e manter um site pesado, e sim preservar a presenca
            institucional com conteudo real, canais claros e performance melhor.
          </p>
          <p>
            Avenida Joaquim Louzada, no 3015, Bairro Novo Colorado, Cuiaba - MT, CEP 78042-515.
          </p>
        </div>
      </section>

      <section className="gallery" aria-label="Galeria de seguros">
        {gallery.map(([label, image], index) => (
          <figure key={image} className={index === 0 ? "gallery-main" : undefined}>
            <img src={`/assets/${image}`} alt={label} />
            <figcaption>{label}</figcaption>
          </figure>
        ))}
      </section>

      <section id="servicos" className="services">
        <div className="section-heading">
          <p className="section-label">Tipos de servicos</p>
          <h2>Coberturas com contexto, nao lista generica.</h2>
          <p>
            Os icones e categorias vieram do acervo legado. A estrutura nova deixa mais facil
            entender a oferta sem depender de WordPress publico.
          </p>
        </div>
        <div className="service-grid">
          {serviceCards.map(([title, text, icon]) => (
            <a key={title} href={quoteHref}>
              <img src={`/assets/${icon}`} alt="" aria-hidden="true" />
              <span>{title}</span>
              <p>{text}</p>
            </a>
          ))}
        </div>
      </section>

      <section id="parceiros" className="insurers" aria-label="Seguradoras associadas">
        <div className="section-heading">
          <p className="section-label">Seguradoras associadas</p>
          <h2>Logos reais para reforcar confianca e reconhecimento.</h2>
          <p>
            A parede de marcas ajuda o visitante a perceber rapidamente que existe operacao,
            historico e relacionamento com seguradoras do mercado.
          </p>
        </div>
        <div className="logo-wall">
          {insurers.map(([name, image]) => (
            <figure key={image}>
              <img src={`/assets/${image}`} alt={name} width="190" height="100" />
              <figcaption>{name}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section id="contato" className="contact">
        <div>
          <p className="section-label">Fale conosco</p>
          <h2>Solicite uma avaliacao de seguro.</h2>
          <p>
            Envie o tipo de seguro, cidade, perfil do risco e melhor telefone para retorno.
            A equipe responde pelo canal mais direto.
          </p>
        </div>
        <div className="contact-panel">
          {contactItems.map(([icon, label, href]) => (
            <a className="contact-link" href={href} key={label}>
              <span className={`icon ${icon}`} aria-hidden="true"></span>
              <span>{label}</span>
            </a>
          ))}
          <a className="button primary" href={quoteHref}>Enviar pedido de cotacao</a>
        </div>
      </section>

      <footer>
        <div className="footer-legal">
          <span>© 2026 Domazi Seguros. Todos os direitos reservados.</span>
        </div>
        <div className="cod5-credit">
          <span>Desenvolvido e Hospedado por</span>
          <a
            href="https://codigo5.com.br/?utm_source=domaziseguros.com.br&utm_medium=codigo5.com.br&utm_campaign=footer-credit"
            target="_blank"
            rel="nofollow noopener"
          >
            <picture>
              <source srcSet="/assets/codigo5-credit.webp" type="image/webp" />
              <img src="/assets/codigo5-credit.jpg" alt="Codigo5" width="110" height="28" />
            </picture>
            <span>codigo5.com.br</span>
          </a>
        </div>
      </footer>
    </main>
  );
}

export default App;
